module.exports = {
  apiUrl: "https://zr0.in/api/",
  baseUrl: "https://zr0.in"
};



// WEBPACK FOOTER //
// ./src/config/constants.js